<template>
    <div class="device-type-manange relative">
        <div class="buttons">
            <el-button @click="resetForm">重置</el-button>
            <el-button @click="search">筛选</el-button>
            <el-button :id="'hospitalAdd'" @click="addDoctorVisits">新增</el-button>
        </div>

        <!-- 表单开始 -->
        <el-row class="inputs mg-20" :gutter="20">
            <el-col :md="6" :lg="6" :xl="4">
                <span class="fs-14 pd-r-10">专家姓名：</span>
                <el-input v-model="user_name" placeholder="专家姓名模糊搜索"/>
            </el-col>
            <el-col :md="6" :lg="6" :xl="4">
                <span class="fs-14 pd-r-10">科室：</span>
                <el-select v-model="hospital_department_id" placeholder="请选择科室">
                    <el-option
                        v-for="item in allHospitalDepartment"
                        :key="item.id"
                        :label="item.department_name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-col>
            <el-col :md="9" :lg="9" :xl="5">
                <span class="fs-14 pd-r-10">排班时间：</span>
                <el-date-picker
                    v-model="search_expired_date"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                ></el-date-picker>
            </el-col>
        </el-row>
        <el-row class="inputs mg-20" :gutter="20">
            <el-col :md="6" :lg="6" :xl="4">
                <span class="fs-14 pd-r-10">手机号码：</span>
                <el-input v-model="mobile" placeholder="手机号码模糊搜素"/>
            </el-col>
            <el-col :md="6" :lg="6" :xl="4">
                <span class="fs-14 pd-r-10">状态：</span>
                <el-select v-model="status" placeholder="请选择状态">
                    <el-option
                        v-for="item in allStatus"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-col>
            <el-col :md="9" :lg="9" :xl="5">
                <span class="fs-14 pd-r-10"> &nbsp;&nbsp;&nbsp;&nbsp;时间段：</span>
                <el-select v-model="half" placeholder="请选择状态">
                    <el-option
                        v-for="item in allhalf"
                        :key="item.name"
                        :label="item.name"
                        :value="item.name"
                    ></el-option>
                </el-select>
            </el-col>
        </el-row>
        <!-- 表单结束 -->
        <el-table :data="tableData" border style="width: 100%">
            <el-table-column width="50px" prop="no" label="序号" align="center"
                             label-class-name="label"></el-table-column>
            <el-table-column width="130" prop="user_name" label="专家姓名" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="140" prop="mobile" label="手机号码" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="180" prop="department_name" label="科室" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="200px"  label="排班时间" align="center" label-class-name="label">
                <template slot-scope="scope">
                    {{scope.row.visit_date}}({{scope.row.half}})
                </template>
            </el-table-column>
            <el-table-column label="排班地点" align="center" label-class-name="label">
                <template slot-scope="scope">
                    {{scope.row.region_name}} {{scope.row.address}}
                </template>
            </el-table-column>
            <el-table-column width="120px" prop="status" label="状态" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="240px" prop="address" label="操作" align="center" label-class-name="label" v-slot="scope">
                <el-button @click="edit(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="startStopVisits(scope.row,2)" v-if="scope.row.status_number==1" type="text" size="small">停用</el-button>
                <el-button @click="startStopVisits(scope.row,1)" v-if="scope.row.status_number==2" type="text" size="small">启用</el-button>
                <el-button @click="delVisits(scope.row)" type="text" size="small">删除</el-button>
            </el-table-column>
        </el-table>
        <el-pagination
            class="mg-20 ta-r"
            background
            layout="total, sizes, prev, pager, next, jumper"
            :page-sizes="[10, 25, 50, 100]"
            :total="total"
            :page-size="perpage"
            :current-page="page"
            @current-change="changePage"
            @size-change="changeSite"
        ></el-pagination>
    </div>
</template>
<script>
import {check} from "@/utils/checkData";
import {authUrlCheck, base64Parser, getBase64Image, loadFile} from "@/api/order";
import {getUserInfos} from "@/utils/userInfos";
import PizZip from "pizzip";
import Docxtemplater from "docxtemplater";
import {saveAs} from "file-saver";
import ImageModule from "docxtemplater-image-module-free";
import env from "@/api/env";

export default {
    data() {
        return {
            role_id: 0,
            child_role_id: 0,
            admin_user_name: '',
            admin_user_mobile: '',
            page: 1,
            perpage: 10,
            total: 0,
            tableData: [],
            user_name: '',
            mobile: '',
            hospital_department_id: '',
            status: '',
            start_expired_date: '',
            end_expired_date: '',
            search_expired_date: [],
            allHospitalDepartment: [],
            doctor_id: '',
            allStatus: [
                {
                    id: 1,
                    name: '启用'
                },
                {
                    id: 2,
                    name: '停用'
                },
            ],
            half:"",
            allhalf: [
                { name: '上午'},
                { name: '下午'},
                { name: '全天'},
            ],
            is_submit: false,
        };
    },
    created() {
        let userInfo = getUserInfos()
        if (userInfo) {
            this.role_id = parseInt(userInfo.role_id)
            this.child_role_id = parseInt(userInfo.child_role_id)
        }

        if (this.$route.params.hospital_department_id) {
            this.hospital_department_id = this.$route.params.hospital_department_id;
        }
        if (this.$route.params.hospital_id) {
            this.hospital_id = this.$route.params.hospital_id;
        }
        if (this.$route.query.hospital_department_id) {
            this.hospital_department_id = this.$route.query.hospital_department_id;
        }
        if (this.$route.query.hospital_id) {
            this.hospital_id = this.$route.query.hospital_id;
        }
        if (this.$route.query.status == 1) {
            this.status = 1
        }
        if (this.$route.query.doctor_name) {
            this.user_name = this.$route.query.doctor_name
        }
        if (this.$route.query.doctor_id) {
            this.doctor_id = this.$route.query.doctor_id
        }
        if (this.$route.query.start_time) {
            this.search_expired_date[0] = this.$route.query.start_time;
            this.start_expired_date = this.$route.query.start_time;
        }
        if (this.$route.query.end_time) {
            this.search_expired_date[1] = this.$route.query.end_time;
            this.end_expired_date = this.$route.query.end_time;
        }
    },
    mounted() {
        // 获取列表
        this.getList();

        // 获取所有医院类型
        this.listParams();

    },
    activated() {

    },
    deactivated() {

    },
    methods: {
        // 获取所有设备类型
        getList() {
            let params = {
                servername: 'Ruyi_AdminExpertServices',
                method: 'visitsListing',
                pageinfo: {
                    page: this.page,
                    perpage: this.perpage,
                },
                params: {
                    doctor_name: this.user_name,
                    doctor_id: this.doctor_id,
                    mobile: this.mobile,
                    hospital_id: this.hospital_id,
                    hospital_department_id: this.hospital_department_id,
                    status: this.status,
                    half: this.half,
                    start_visit_date: this.start_expired_date,
                    end_visit_date: this.end_expired_date,
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    this.is_submit = false;
                    return;
                }
                for (var i = 0; i < res.data.data.list.length; i++) {
                    // 以序号代替ID
                    res.data.data.list[i].no = (this.page - 1) * this.perpage + i + 1

                    switch (res.data.data.list[i].status) {
                        case '1':
                            res.data.data.list[i].status = '启用';
                            res.data.data.list[i].status_number = '1';
                            break;
                        case '2':
                            res.data.data.list[i].status = '停用';
                            res.data.data.list[i].status_number = '2';
                            break;
                    }
                }
                this.tableData = res.data.data.list;
                this.total = res.data.data.page.count;
                this.is_submit = false;
            }).catch(() => {
                this.is_submit = false;
            }).finally(() => {
                this.is_submit = false;
            });
        },

        listParams() {
            let params = {
                servername: 'Ruyi_AdminExpertServices',
                method: 'listParams',
                pageinfo: {
                    page: this.page,
                    perpage: this.perpage,
                },
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                this.allHospital = res.data.data.hospital;
                this.allHospitalDepartment = res.data.data.hospital_department;
            });
        },

        // 改变每页条数
        changeSite(index) {
            this.perpage = index;
            this.getList();
        },

        //更换页码
        changePage(index) {
            this.page = index;
            this.getList();
        },

        // 重置按钮
        resetForm() {
            if (this.is_submit) {
                // 重复提交提醒
                this.$message({
                    type: "warning",
                    message: '正在处理请求，请不要重复操作',
                    duration: 1500,
                });
                return;
            }
            this.is_submit = true;
            this.user_name = "";
            this.doctor_id = "";
            this.mobile = "";
            this.hospital_department_id = "";
            this.status = "";
            this.half = "";
            this.start_expired_date = "";
            this.end_expired_date = "";
            this.search_expired_date = "";
            this.page = 1;
            this.getList();
        },

        // 搜索
        search() {
            if (this.is_submit) {
                // 重复提交提醒
                this.$message({
                    type: "warning",
                    message: '正在处理请求，请不要重复操作',
                    duration: 1500,
                });
                return;
            }
            this.is_submit = true;
            if (this.search_expired_date) {
                this.start_expired_date = this.search_expired_date[0];
                this.end_expired_date = this.search_expired_date[1];
            }

            this.page = 1;
            this.getList();
        },

        // 跳转添加页
        addDoctorVisits() {
            // this.$router.push({name: "doctorAdd", params: {}});

            if (this.role_id > 1) {
                if (!authUrlCheck('/admin/doctor/DoctorVisitsAdd', this.$store.getters.authUrl)) {
                    return;
                }
            }

            // 新窗口打开
            let url = this.$router.resolve({
                name: "doctorVisitsAdd",
                query: {}
            })

            window.open(url.href, '_blank')
        },

        // 跳转编辑页
        edit(data) {
            // 新窗口打开
            let url = this.$router.resolve({
                name: "doctorVisitsEdit",
                query: {id: data.id}
            })
            window.open(url.href, '_blank')
        },
        // 启用停用排班时间
        startStopVisits(data, status) {
            if (this.is_submit) {
                // 重复提交提醒
                this.$message({
                    type: "warning",
                    message: '正在处理请求，请不要重复操作',
                    duration: 1500,
                });
                return;
            }
            this.is_submit = true;
            if (status == '1') {
                var message = '确定启用该排班时间吗？';
            }
            if (status == '2') {
                var message = '确定停用该排班时间吗？';
            }
            this.$confirm(message, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let params = {
                    servername: 'Ruyi_AdminExpertServices',
                    method: 'startStopVisits',
                    pageinfo: {
                        page: this.page,
                        perpage: this.perpage,
                    },
                    params: {
                        user_id: data.user_id,
                        status: status
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        this.is_submit = false;
                        return;
                    }
                    this.$message({
                        type: "success",
                        message: '修改成功',
                        duration: 1500,
                    });
                    this.getList();
                    this.is_submit = false;
                }).finally(() => {
                    this.is_submit = false;
                });
            }).catch(() => {
                this.is_submit = false;
            }).finally(() => {
                this.is_submit = false;
            });
        },
        delVisits(data){
            if (this.is_submit) {
                // 重复提交提醒
                this.$message({
                    type: "warning",
                    message: '正在处理请求，请不要重复操作',
                    duration: 1500,
                });
                return;
            }
            this.is_submit = true;
            this.$confirm('确定要删除排班时间吗', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let params = {
                    servername: 'Ruyi_AdminExpertServices',
                    method: 'delVisits',
                    params: {
                        id: data.id,
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        this.is_submit = false;
                        return;
                    }
                    this.$message({
                        type: "success",
                        message: '删除成功',
                        duration: 1500,
                    });
                    this.getList();
                    this.is_submit = false;
                }).finally(() => {
                    this.is_submit = false;
                });
            }).catch(() => {
                this.is_submit = false;
            }).finally(() => {
                this.is_submit = false;
            });
        },


    }
};

</script>
<style lang="scss">
@import "@/styles/common.scss";

.docker_buttons {
    float: right;
    margin: 30px 0px 8px 0px;

    .el-button {
        width: 150px;
        height: 32px;
        line-height: 7px;
    }
}

.inputs .el-select {
    max-width: none !important;
}
</style>
